var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5C6BC0",
    d: "M40,40c-6.9,0-16,4-16,4V22c0,0,9-4,18-4L40,40z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7986CB",
    d: "M8,40c6.9,0,16,4,16,4V22c0,0-9-4-18-4L8,40z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFB74D"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 12,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,32h1c0.6,0,1-0.4,1-1v-4c0-0.6-0.4-1-1-1h-1c-1.7,0-3,1.3-3,3v0C38,30.7,39.3,32,41,32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,26H6c-0.6,0-1,0.4-1,1v4c0,0.6,0.4,1,1,1h1c1.7,0,3-1.3,3-3v0C10,27.3,8.7,26,7,26z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReading);
export default __webpack_public_path__ + "static/media/reading.684447df2a39e5db9b1a231a29d2b4ee.svg";
export { ForwardRef as ReactComponent };